<template>
  <div class="w-full info-page">
    <div class="mb-10 flex flex-row items-center justify-center">
      <BaseIcon class="mr-2" name="logo" width="28" height="32" />
      <div class="font-bold text-xs">Информирование граждан</div>
    </div>
    <p>Вы успешно зарегистрировались!</p>

    <p class="mb-4">
      На указанную почту высланы данные для входа в портал.
    </p>

    <div class="mb-8">
      <BaseButton class="w-full" size="md" variant="blue" @click="goToSignIn">
        Войти
      </BaseButton>
    </div>
  </div>
</template>

<script>
  import BaseIcon from '@/components/global/base-icon';
  import BaseButton from '@/components/global/base-button';

  export default {
    name: 'RegisterInfoPage',

    components: {
      BaseIcon,
      BaseButton,
    },

    methods: {
      goToSignIn() {
        this.$router.push({name: 'auth.login'});
      },
    },
  };
</script>
<style lang="scss" scoped>
  .info-page {
    width: rem(312px);
    text-align: center;
  }
</style>
